import { NgModule } from '@angular/core';
import { MailsOrderComponent } from './mails-order.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularFrameworkModule } from 'sp-office365-framework';
import {
    FuseSharedModule,
    LayoutModule,
    FuseSidebarModule,
} from 'sp-office365-layout';
import { DetailMailModule } from '../../mail/detail-mail/detail-mail.module';
import { ResizableBoxModule } from 'src/app/main/shared/components/resizable-box/resizable-box.module';
import { FilterMailModule } from '../../mail/filter-mail/filter-mail.module';

const routes = [
    {
        path: 'orders/detail/mails',
        component: MailsOrderComponent,
    },
    {
        path: 'orders/detail/mails/:id',
        component: MailsOrderComponent,
    },
];

@NgModule({
    declarations: [MailsOrderComponent],
    imports: [
        RouterModule.forChild(routes),
        TranslateModule,
        FuseSharedModule,
        LayoutModule,
        MatIconModule,
        MatTabsModule,
        MatSnackBarModule,
        FuseSidebarModule,
        AngularFrameworkModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        DetailMailModule,
        ResizableBoxModule,
        FilterMailModule
    ],
    exports: [MailsOrderComponent],
})
export class MailsOrderModule {}
